// extracted by mini-css-extract-plugin
module.exports = {"container":"WithLabAlias_container__2M-8z"};